require('./openYoungCardPaymentChoresView.scss');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

//@ utilities
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getFormattedString, formatCurrency } = require('utilities/currencyHelper');
const { toCamelCase } = require('utilities/stringHelper');
const AccessHelper = require('utilities/accessHelper');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const { getCardAvailableBalance } = require('utilities/cardsHelper');

// @components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const { PaymentChoreStep1 } = require('components/cards/cardOpenYoung/cardOpenYoungPaymentChoreSteps/paymentChoreStep1');
const { PaymentChoreStep2 } = require('components/cards/cardOpenYoung/cardOpenYoungPaymentChoreSteps/paymentChoreStep2');
const WizardError = require('components/commons/wizardError/wizardError')
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @actions
const openYoungCardPaymentChore = require('actions/openYoungCardPaymentChore');
const openYoungCardChores = require('actions/openYoungCardChores');
const openYoungCardChoreStatusUpdate = require('actions/openYoungCardChoreStatusUpdate');
const { getECardInformation } = require('actions/eCardInformation');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @constants
const { FIRST_STEP, EURO_TEXT, CARD_ECARD } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class OpenYoungCardPaymentChoresView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { match: { params: { choreAssignmentId } }, getChoreDetail, resetState } = this.props;
        resetState();
        getChoreDetail(choreAssignmentId);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } }, immAccountsState, setAllAccountsToInactive } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const type = immCard.get('type');
        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        if (type === CARD_ECARD) {
            this.props.getECardInformation(cardId);
        }

        const allAccountsInactive = hasAllAccountsInactive(immAccountsState.get('byOrder').toJS(), immAccountsState.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { openYoungCardChores: nextOpenYoungCardChores, immCards: nextImmCards } = nextProps;
        const { openYoungCardChores, setAmount, immCards, match: { params: { cardId } }, setCardAvailableBalance } = this.props;
        const amount = openYoungCardChores.getIn(['choreDetail', 'reward']);
        const nextAmount = nextOpenYoungCardChores.getIn(['choreDetail', 'reward']);
        const immCard = immCards.getIn(['byId', cardId]);
        const nextImmCard = nextImmCards.getIn(['byId', cardId]);

        const cardAvailableBalance = getCardAvailableBalance(immCard).amount;
        const nextCardAvailableBalance = getCardAvailableBalance(nextImmCard).amount;

        if (nextAmount !== amount) {
            setAmount(nextAmount);
        }

        if (cardAvailableBalance !== nextCardAvailableBalance || nextCardAvailableBalance !== 0) {
            setCardAvailableBalance(nextCardAvailableBalance);
        }
    }

    componentWillUnmount() {
        this.props.openYoungChoreResetStatusUpdateInfo();
    }

    buildErrorWizard(immCard) {
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('openYoungRejectChores-errorTitle')}
                    mainButton={mainButton}
                >
                    <div className="openyoung-card-payment-chore-view__error-body">
                        <div className="col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} />
                        </div>
                        <p className="openyoung-card-payment-chore-view__error-sub-message col-md-7">
                            <FormattedText value="openYoungPaymentChores-errorBodyText" />
                        </p>
                    </div>
                </WizardError>
            </div>
        );
    }

    createList(list) {
        return list.filter(({ bodyText }) => bodyText).map((item, key) => (
            <OKInformativeListItem
                className={"payment-chores-step__list-item"}
                key={key}
                title={item.title}
                bodyText={item.bodyText}
            />
        ));
    }

    buildSuccessWizard(immCard) {
        const { openYoungCardChores, immOpenYoungCardPaymentChore, immAccountsState } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const immStep = immOpenYoungCardPaymentChore.get('steps').get(FIRST_STEP);
        const amountReward = immStep.get('amount');
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        const amount = getFormattedString({
            amount: amountReward,
            currency: formatCurrency(EURO_TEXT)
        });
        const availableBalance = getFormattedString({
            amount: immStep.get('cardAvailableBalance') + amountReward,
            currency: formatCurrency(EURO_TEXT)
        });

        const fromAccount = immStep.get('fromAccount');
        const immAccounts = immAccountsState.get('byId');
        const originAccount = immAccounts.get(fromAccount);
        const originAccountAlias = originAccount.get('alias') || toCamelCase(originAccount.get('accountType'));
        const originAccountText = `${originAccountAlias} ...${originAccount.get('iban').substr(-4)}`;
        const taskType = formatText(`openYoungCardChores-task${choreDetail.getIn(['chore', 'choreId'])}`);
        const list = [
            {
                title: formatText('openYoungPaymentChores-chore'),
                bodyText: taskType
            },
            {
                title: formatText('openYoungPaymentChores-amount'),
                bodyText: amount
            },
            {
                title: formatText('openYoungPaymentChores-numeroOriginAccount'),
                bodyText: originAccountText
            },
            {
                title: formatText('openYoungPaymentChores-newBalance'),
                bodyText: availableBalance
            },
            {
                title: formatText('openYoungPaymentChores-concept'),
                bodyText: immStep.get('remark')
            }
        ];

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardSuccess
                    successMessage={formatText('openYoungPaymentChores-successTitle')}
                    mainButton={mainButton}
                >
                    <div className="openyoung-card-payment-chore-view__error-body">
                        <div className="col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} />
                        </div>
                        <div className="col-md-7 openyoung-card-payment-chore-view__success-list">
                            <OKInformativeList>
                                {this.createList(list)}
                            </OKInformativeList>
                        </div>
                    </div>
                </WizardSuccess>
            </div>
        );
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleFinish() {
        const { match: { params: { cardId, choreAssignmentId } }, paymentTransferConfirmation, immAccountsState, immOpenYoungCardPaymentChore, immCards, openYoungCardChores } = this.props;
        const immStep = immOpenYoungCardPaymentChore.get('steps').get(FIRST_STEP);
        const fromAccount = immStep.get('fromAccount');
        const immAccount = immAccountsState.getIn(['byId', fromAccount]);
        const amount = immStep.get('amount');
        const immCard = immCards.getIn(['byId', cardId]);
        const choreDetail = openYoungCardChores.get('choreDetail');
        paymentTransferConfirmation(immAccount, amount, immCard, immStep.get('remark'), choreAssignmentId, choreDetail);
    }

    buildWizard(immCard) {
        const { immOpenYoungCardPaymentChore, immFlagBasedFeatures, validateStep, setVisibleStep, openYoungCardChores, setWillCancel, immAccountsState, openYoungCardChoreStatusUpdateInfo, immCardCharge } = this.props;
        const accountsList = immAccountsState.get('byOrder');
        const originAccountsMap = immAccountsState.get('byId');
        const immSteps = immOpenYoungCardPaymentChore.get('steps');
        const choreDetail = openYoungCardChores.get('choreDetail');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungCardPaymentChore.get('visibleStep')}
                showPreLeaveModal={true}>
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immCardCharge.get('isFetching')}
                >
                    <PaymentChoreStep1
                        immAccounts={originAccountsMap}
                        accountsIndexes={accountsList.toJS()}
                        immStep={immSteps.get(FIRST_STEP)}
                        immCard={immCard}
                        immCardCharge={immCardCharge}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        choreDetail={choreDetail}
                        childName={immCard.get('beneficiaryName')}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="openYoungRejectChores-Confirm"
                    addLoadingBehaviour={false}
                    isLoading={openYoungCardChoreStatusUpdateInfo.get('isFetching')}

                >
                    <PaymentChoreStep2
                        immStep={immSteps.get(FIRST_STEP)}
                        immAccounts={originAccountsMap}
                        choreDetail={choreDetail}
                        childName={immCard.get('beneficiaryName')}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        const { immCards, match: { params: { cardId } }, openYoungCardChoreStatusUpdateInfo, immCardCharge } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.get('alias').get('current');

        let bodyContent;
        if (immCards.get('isFetching')) {
            bodyContent = <LoadingSection />;
        } else if (immCard) {
            const commonPath = '/myprofile/cards';
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: commonPath
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `${commonPath}/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-openYoungChores'),
                    url: `${commonPath}/${cardId}/chores`
                },
                {
                    text: formatText('breadcrumb-openYoungPaymentChores')
                }
            ];

            let content;
            if (openYoungCardChoreStatusUpdateInfo.get('submitSuccessful')) {
                content = this.buildSuccessWizard(immCard);
            } else if (openYoungCardChoreStatusUpdateInfo.get('submitError') || immCardCharge.get('blockFlow')) {
                content = this.buildErrorWizard(immCard);
            } else if (openYoungCardChoreStatusUpdateInfo.get('allAccountsInactive')) {
                content = (
                    <div className="col-xs-12 col-md-offset-1 col-md-10">
                        <InactiveAccountsError
                            navigateToBackButtonText={'cards'}
                            navigateToBackButtonURL={'cards'}
                        />
                    </div>
                );
            } else {
                content = (
                    <div>
                        <div className="col-md-12 col-lg-8">
                            {this.buildWizard(immCard)}
                        </div>
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                    </div>
                );
            }
            bodyContent = (
                <div className="openyoung-card-payment-chore-view">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle('openYoungPaymentChores-title')}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return bodyContent;
    }
}

OpenYoungCardPaymentChoresView.propTypes = {
    getChoreDetail: PropTypes.func,
    getECardInformation: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountsState: PropTypes.object.isRequired,
    immCards: PropTypes.object,
    immCardCharge: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immOpenYoungCardPaymentChore: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object.isRequired,
    openYoungChoreResetStatusUpdateInfo: PropTypes.func.isRequired,
    match: PropTypes.object,
    paymentTransferConfirmation: PropTypes.func,
    resetState: PropTypes.func,
    setAccountAvailableBalance: PropTypes.func,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    setCardAvailableBalance: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func.isRequired
}

module.exports.Constructor = OpenYoungCardPaymentChoresView;
module.exports.OpenYoungCardPaymentChoresView = connect(
    state => ({
        immAccountsState: state.accounts,
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immOpenYoungCardPaymentChore: state.openYoungCardPaymentChore,
        openYoungCardChores: state.openYoungCardChores,
        openYoungCardChoreStatusUpdateInfo: state.openYoungCardChoreStatusUpdateInfo
    }),
    {
        getChoreDetail: openYoungCardChores.getChoreDetail,
        getECardInformation: getECardInformation,
        openYoungChoreResetStatusUpdateInfo: openYoungCardChoreStatusUpdate.openYoungChoreResetStatusUpdateInfo,
        paymentTransferConfirmation: openYoungCardPaymentChore.paymentTransferConfirmation,
        resetState: openYoungCardPaymentChore.resetState,
        setAccountAvailableBalance: openYoungCardPaymentChore.setAccountAvailableBalance,
        setAllAccountsToInactive: openYoungCardPaymentChore.setAllAccountsToInactive,
        setAmount: openYoungCardPaymentChore.setAmount,
        setCardAvailableBalance: openYoungCardPaymentChore.setCardAvailableBalance,
        setRemark: openYoungCardPaymentChore.setRemark,
        setVisibleStep: openYoungCardPaymentChore.setVisibleStep,
        setWillCancel: openYoungCardPaymentChore.setWillCancel,
        validateStep: openYoungCardPaymentChore.validateStep
    })(withRouter(OpenYoungCardPaymentChoresView));
